
import styled from 'styled-components';
import theme from '../../../theme';

const StyledPropelCorporateGifting = styled.div`
  background: ${theme.blenderCreamy};
  overflow-x: hidden;
  height: 100vh;
  .default_class, .scroll_class{
    display: none;
  }
  .nav-propel-corp-gift{
    padding: 0.8rem 0rem;
    background: ${theme.whiteColor};
    box-shadow: 0px 2px 5px ${theme.borderGray};
    position: relative;
    .propel-logo{
      width: 26%;
    }
    .btn-right{
      text-align: right;
    }
    .xmas-santa{
      position: absolute;
      left: 25rem;
      top: 4.6rem;
      width: 6%;
    }
  }
  .propel-corp-gifts{
    text-align: left;
    .corp-gift-headline{
      font-size: 44px;
      color: ${theme.LandingBlack};
      margin-bottom: 10px;
      line-height: 50px;
    }
    .hr-line{
      height: 10px;
      width: 80px;
      border: none;
      border-radius: 10px;
      background: ${theme.primaryColor};
      margin: 10px 10px 10px 0px;
    }
    .color-red{
      color: ${theme.primaryColor};
      font-size: 20px;
    }
    .propel-corp-lamp{
      width: 40px;
      vertical-align: sub;
    }
    .highlight-theme{
      z-index: 99;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    .nav-propel-corp-gift{
      padding: 0.8rem 0.6rem;
      .propel-logo{
        width: 65%;
      }
    }
    .highlight-theme{
      padding: 0px 10px;
    }
    .xmas-santa{
      top: 5.5rem !important;
      width: 15% !important;
      left: 20rem !important;
    }
  }
`;


export default StyledPropelCorporateGifting;



// WEBPACK FOOTER //
// client/containers/Campaigns/PropelCorporateGifting/StyledPropelCorporateGifting.js